<template>
  <v-container fluid>

    <v-row v-if="view.messages.length > 0">
      <v-col cols="12">
        <v-alert type="info" color="red" text v-for="msg in validMessages" :key="msg.id">
          <span class="nl2br">{{ msg.message[$i18n.locale] }}</span>
        </v-alert>
      </v-col>
    </v-row>

    <mp-external-form  ref="externalForm" target="_blank" />
    <v-row justify="center">
      <v-col cols="12">
    <h1>{{$t("message.top.title.services")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="12">
    <v-card
      class="d-flex flex-wrap"
      flat
      tile
    >
      <v-card
        v-for="s in view.services"
        :key="s.id"
        class="pa-2 ma-5"
        outlined
        tile
        hover
        width=250
        @click="clickService(s.serviceUrl)"
      >
        <v-card dark tile color="green" outlined flat>
          <v-card-title>{{ s.serviceName[$i18n.locale] }}</v-card-title>
        </v-card>
        <v-card-text class="text-pre-wrap">{{ s.serviceDscrptn[$i18n.locale] }}</v-card-text>
      </v-card>
    </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MpExternalForm from '@/components/item/MpExternalForm.vue'
import AccountApi from '@/api/account'
import Common from '@/api/common'
import i18n from '@/message'
import IECheckMixin from '@/mixins/iecheck'

export default {
  name: 'top',
  components: {
    MpExternalForm
  },
  data: () => ({
    view: {
      services: [],
      messages: []
    }
  }),
  mixins: [IECheckMixin],
  methods: {
    async loadViewData () {
      this.view.services = await AccountApi.top()
    },
    clickService (url) {
      this.$refs.externalForm.doSubmit(url)
    },
    async loadMessages () {
      this.view.messages = await Common.messageList()
    }
  },
  computed: {
    validMessages: function () {
      return this.view.messages.filter(function (msg) {
        return msg.message[i18n.locale]
      })
    }
  },
  created: function () {
    this.loadViewData()
    this.loadMessages()
  },
  mounted: function () {
    this.alertIfIE()
  }
}
</script>

<style scoped>
.nl2br {
    white-space: pre-wrap;
}
</style>
